import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import 'bootstrap/scss/bootstrap-reboot.scss';
import 'bootstrap/scss/bootstrap-grid.scss';

import './assets/main.scss'

import {INITIAL_LOAD} from "./store/actions";

Vue.config.productionTip = false;

const el = document.getElementById('nl-help-main-app');
if(el) {
    new Vue({
        router,
        store,
        render: h => h(App),
        mounted() {
            this.$store.dispatch(INITIAL_LOAD);
        }

    }).$mount(el);
}

//router.replace('/')